// Geld naar de meter: haalt een verkoop het target, dan springt het bedrag op in het
// midden en vliegt het de teammeter in, en daar vertrekt meteen de aanloop naar 100
// (targetPartyGroup in ./party.js). Alleen bij Film; gedeeld door de tijdlijn
// (hooks/useSaleEvents.js), het beeld (AnimationLayer.js) en het geluid (audio/cues.js).

// Het bedrag springt op en blijft even staan, dan vertrekt het.
export const feedPopMs = 350;

// Waar het in de meter landt.
export const feedLandMs = 1350;

// De vonken bij de meter zijn dan nog bezig.
export const feedMs = 1900;

// De meter veert na de landing (gauge-pulse), en dan vliegt hij naar het midden.
export const feedSettleMs = 250;
